const VERSION_CHECK_INTERVAL_MS = 60_000;
const PUBLIC_URL = process.env.PUBLIC_URL || '';
const VERSION_FILE_URL = `${PUBLIC_URL}/app-version.json`;
const CURRENT_VERSION = process.env.REACT_APP_BUILD_VERSION;

let intervalId: number | undefined;

async function checkVersion(): Promise<void> {
  if (!CURRENT_VERSION) {
    return;
  }

  try {
    const response = await fetch(`${VERSION_FILE_URL}?t=${Date.now()}`, {
      cache: 'no-store',
    });

    if (!response.ok) {
      return;
    }

    const data = await response.json();
    const latestVersion = data?.version;

    if (latestVersion && latestVersion !== CURRENT_VERSION) {
      window.location.reload();
    }
  } catch {
    // A failed version check should not interrupt app startup.
    console.warn('Version check failed. Could not fetch the latest version.');
  }
}

function handleVisibilityChange(): void {
  if (document.visibilityState === 'visible') {
    checkVersion();
  }
}

export function startVersionCheck(): void {
  if (
    process.env.NODE_ENV !== 'production'
    || !CURRENT_VERSION
    || intervalId !== undefined
  ) {
    return;
  }

  checkVersion();
  intervalId = window.setInterval(checkVersion, VERSION_CHECK_INTERVAL_MS);
  document.addEventListener('visibilitychange', handleVisibilityChange);
}

